import { Component } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { JoiApp } from 'globals/store/app.data';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { loadProgramTexts } from 'globals/store/programs.data';
import { MobileAppSubpage } from '../mobile-store/mobile.data';
import { mobileHomePageMenuReselector } from '../mobile-store/mobile.app.reselector';
import { MobileAppHomeMenuComponent } from '../mobile-nav/mobile-app-home-menu.component';
import { HomePageComponent } from '../../branding/home-page.component';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-app-homepage',
    template: `
<mobile-app-home-menu *ngIf="!!subPages.length" (clickSubpage)="changeSubpage($event)"></mobile-app-home-menu>
<home-page *ngIf="!!app?.eventData" 
  [brandingData]="app.brandingData" 
  [homePageData]="app.eventData.homePageData" 
  [isApp]="true"
  [tabNames]="{}"
></home-page>
`,
    styleUrls: ['./mobile-home.scss'],
    standalone: true,
    imports: [MobileAppHomeMenuComponent, CommonModule, HomePageComponent]//
})
export class MobileHomeComponent  extends MobileAppWrapper<MobileHomeComponent> {
  app: JoiApp
  allowedToLoad: boolean
  programTexts = {}
  tabNames:{ [tId: string]: string } = getDefaultProgramTabNames() 
  subPages: MobileAppSubpage[] = []

  
  constructor() {
    super()
    this.selectProp(mobileHomePageMenuReselector, null, 'subPages')
    this.subCallback(this.store.select(mobileAppFeature.selectApp), app => {
      this.app = app
      // console.log({ app })
      if (!app) return
      const { tabNames, timeline, excludedFieldIds, eventInfo } = app.eventData
      if (tabNames) this.tabNames = tabNames
      this.programTexts = loadProgramTexts(timeline, excludedFieldIds, eventInfo.venues)
    })
  }

  changeSubpage(subPage: MobileAppSubpage) {
    this.mobileAppService.changeSubpage(subPage)
  }

}

